class CardSliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="js-slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="js-slide-"]');
    this.sliderItemsZoom = this.querySelectorAll('.js-slide-product-image-zoom');
    this.enableSliderLooping = false;
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.sliderToggleId = this.dataset.toggle;
    this.toggleInputs = this.closest('.product-slider')?.querySelectorAll('input[class^="js-input-"');

    this.toggleInputs && this.toggleSlider();

    this.thumbnails = this.querySelectorAll(".js-pagination-dot");

    if (!this.slider || !this.nextButton) return;

    this.stepDesktop = this.nextButton.dataset.stepDesktop || 1;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    setTimeout(() => {
      this.slider.classList.add('card-slider-scroll');
    }, 200);

    this._attachEventHandlers()
  }

  _attachEventHandlers() {
    this.thumbnails?.forEach(el => {
      el.addEventListener("click", this.scrollSlideIntoView.bind(this));
    })

    this.sliderItemsZoom?.forEach(el => {
      el.addEventListener("click", () => { document.dispatchEvent(new CustomEvent('open-modal', {
        detail: {
          modal_name: 'js-product-image-zoom',
          payload: el.id
        }
      }))})
    })

    document.addEventListener('updatedSliderData', () => this.reinitializeSlider(), false)

    this.slider.addEventListener('scroll', this.update.bind(this), {passive: true});
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0) || [...this.sliderItems];
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.update();
    this.scrollSlideIntoView(1);
  }

  reinitializeSlider() {
    this.slider = this.querySelector('[id^="js-slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="js-slide-"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.slider.addEventListener('scroll', this.update.bind(this), {passive: true});
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    this.stepDesktop = this.nextButton.dataset.stepDesktop || 1;
    this.initPages();
  }

  update() {
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    if (this.prevButton.hasAttribute('disabled') && this.nextButton.hasAttribute('disabled')) {
      this.prevButton.classList.add('hidden');
      this.nextButton.classList.add('hidden');
    } else {
      this.prevButton.classList.remove('hidden');
      this.nextButton.classList.remove('hidden');
    }

    this.sliderItems.forEach(item => {
      item.classList.remove('current-slide');
    });
  
    // add current-slide to the slide that is currently visible
    const visibleSlide = Array.from(this.sliderItemsToShow).find(slide => this.isSlideVisible(slide));
    visibleSlide && visibleSlide.classList.add('current-slide');
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset + 5;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = isTablet() ? this.stepDesktop : 1
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });

    // remove current-slide from the current slide before scrolling to the previous slide
    const currentSlide = this.querySelector('.current-slide');
    currentSlide && currentSlide.classList.remove('current-slide');

    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  scrollSlideIntoView(e) {
    const slide = e.target ? e.target.dataset.indexNumber : e;
    const slideWidth = this.sliderItems[0].clientWidth;
    this.slider.scrollTo({
      left: slideWidth * (slide - 1)
    })
  }

  toggleSlider() {
    this.toggleInputs.forEach(input => {
      input.addEventListener('click', this.onToggle.bind(this));
      if (input.checked) {
        this.sliderToggleId === input.id
          ? this.classList.add('active')
          : this.classList.remove('active')
      }
    })
  }

  onToggle(event) {
    this.classList.remove('active');
    const ctaButtons = this.closest('.product-slider').querySelectorAll('.js-button-view-all');
    ctaButtons.forEach(button => {
      button.classList.contains(event.target.id)
        ? button.classList.add('active')
        : button.classList.remove('active')
    })
    if (this.sliderToggleId === event.target.id) { this.classList.add('active') }
  }
}

customElements.define('card-slider', CardSliderComponent);